import { allThemes, BoxProps, TextProps } from '@jfs/ui-new'

const defaultTypeStyle = {
  titleText: {
    fontSize: 14,
    paddingHorizontal: 8,
    paddingVertical: 8,
    color: 'BLACK',
    fontWeight: '800',
    // borderRadius: 8,
    textAlign: 'left',
    numberOfLines: 2,
  } as TextProps,
}

const defaultPositionStyle = {
  position: 'absolute',
  right: 16,
  zIndex: 1000,
  paddingHorizontal: 16,
  paddingVertical: 16,
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  borderRadius: 8,
  marginLeft: 32,
} as BoxProps

export const styles = {
  TOP: { containerView: { ...defaultPositionStyle, top: 72 } as BoxProps },
  BOTTOM: { containerView: { ...defaultPositionStyle, bottom: 16 } as BoxProps },
  CENTER: {
    containerView: { ...defaultPositionStyle, top: 0, bottom: 0 } as BoxProps,
  },
  NEGATIVE: {
    titleText: {
      ...defaultTypeStyle.titleText,
      color: 'WHITE',
    } as TextProps,
    bgColor: {
      backgroundColor: allThemes.light.colors.ERROR,
    } as BoxProps,
  },
  POSITIVE: {
    titleText: {
      ...defaultTypeStyle.titleText,
      color: 'WHITE',
    } as TextProps,
    bgColor: {
      backgroundColor: allThemes.light.colors.GREEN,
    } as BoxProps,
  },
  NEUTRAL: {
    titleText: {
      ...defaultTypeStyle.titleText,
      color: 'WHITE',
    } as TextProps,
    bgColor: {
      backgroundColor: 'PRIMARY',
    } as BoxProps,
  },
}
